function splitTerms(term: string): string[] {
    return term.split(/:(.+)/);
}

export default splitTerms;
